import {ADD_ERROR, CLEAR_ERRORS, REMOVE_ERROR} from 'state/actions';

export default function errorsReducer(state = [], action) {
  switch (action.type) {
    case ADD_ERROR:
      const id = state.length !== 0 ? state[state.length - 1].id + 1 : 0;
      return [...state, {id, error: action.error}];
    case REMOVE_ERROR:
      return state.filter(error => error.id !== action.id);
    case CLEAR_ERRORS:
      return [];
    default:
      return state;
  }
}
